// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"k1e0ZQHEpn2XocHVNHKsq_0","title":"_3sSXiuwAQqSC8nf3nG1b5-_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a4e35e2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dashboard/components/frame/DashboardToolbar.vue
// module id = 4KxO
// module chunks = 75